import React from "react";

import * as S from "./ExtraCharges.styles";

interface iExclusion {
  data: Array<string>;
}
const ExtraChargesUI: React.FC<iExclusion> = ({ data = [] }) => {
  return (
    <S.ExtraChargesLists>
      {data.map((item, index) => (
        <li key={`ExtraChargesLists${index}`}>{item}</li>
      ))}
    </S.ExtraChargesLists>
  );
};

export default ExtraChargesUI;
